var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 2.41667C12.6583 2.41667 15.4749 4.19167 16.8499 7C15.4749 9.80833 12.6666 11.5833 9.49992 11.5833C6.33325 11.5833 3.52492 9.80833 2.14992 7C3.52492 4.19167 6.34158 2.41667 9.49992 2.41667ZM9.49992 0.75C5.33325 0.75 1.77492 3.34167 0.333252 7C1.77492 10.6583 5.33325 13.25 9.49992 13.25C13.6666 13.25 17.2249 10.6583 18.6666 7C17.2249 3.34167 13.6666 0.75 9.49992 0.75ZM9.49992 4.91667C10.6499 4.91667 11.5833 5.85 11.5833 7C11.5833 8.15 10.6499 9.08333 9.49992 9.08333C8.34992 9.08333 7.41658 8.15 7.41658 7C7.41658 5.85 8.34992 4.91667 9.49992 4.91667ZM9.49992 3.25C7.43325 3.25 5.74992 4.93333 5.74992 7C5.74992 9.06667 7.43325 10.75 9.49992 10.75C11.5666 10.75 13.2499 9.06667 13.2499 7C13.2499 4.93333 11.5666 3.25 9.49992 3.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.25e6d024524f04d428116bcc441d3eb3.svg";
export { ForwardRef as ReactComponent };